import { X, AlertTriangle } from 'lucide-react';
import Modal from './Modal';

interface ShotCountChangeConfirmDialogProps {
  currentCycleShotCount: number;
  newCycleShotCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const formatShotCount = (value: number) => (value ?? 0).toLocaleString('th-TH');

const ShotCountChangeConfirmDialog: React.FC<
  ShotCountChangeConfirmDialogProps
> = ({ currentCycleShotCount, newCycleShotCount, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={true} onClose={onCancel}>
      <div className='p-6'>
        <div className='flex justify-between items-center mb-4'>
          <h2 className='text-xl font-semibold flex items-center gap-2'>
            <AlertTriangle size={22} className='text-amber-500' />
            ยืนยันการแก้ไขชอตสะสมในรอบล้าง
          </h2>
          <button
            onClick={onCancel}
            className='text-gray-400 hover:text-gray-600 focus:outline-none'
          >
            <X size={24} />
          </button>
        </div>

        <p className='text-gray-600 mb-2'>
          ชอตสะสมจากระบบในรอบล้างจะถูกเปลี่ยนจาก{' '}
          <span className='font-semibold text-gray-900'>
            {formatShotCount(currentCycleShotCount)}
          </span>{' '}
          เป็น{' '}
          <span className='font-semibold text-gray-900'>
            {formatShotCount(newCycleShotCount)}
          </span>
        </p>
        <p className='text-gray-600 mb-6'>
          ค่านี้มีผลต่อการแจ้งเตือนรอบล้างบำรุงรักษาของแม่พิมพ์
          การแก้ไขจะถูกบันทึกไว้ใน Audit logs
        </p>

        <div className='flex justify-end space-x-1'>
          <button
            onClick={onCancel}
            className='px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
          >
            ยกเลิก
          </button>
          <button
            onClick={onConfirm}
            className='px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
          >
            ยืนยันการแก้ไข
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ShotCountChangeConfirmDialog;
